import { Component } from '@angular/core';
import { Card } from 'primeng/card';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { TranslocoModule } from '@jsverse/transloco';

interface Invoice {
  id: string;
  date: string;
  amount: string;
  status: 'Paid' | 'Pending' | 'Failed';
}

@Component({
  selector: 'app-billing',
  standalone: true,
  imports: [],
  template: `
<iframe 
  style="height: calc(100vh - 80px);width:100%"
  src="https://pay.grow.link/MTAwODUy~2c8c92c883ee2f187e83e1755ed6e0fd-MzQ0ODExNA">
  `
})
export class BillingComponent {

}
